// import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base } from '@/store/base/module'
import ApiUtils from '@/utils/api/ApiUtils'
import moment from 'moment'


/**
 * @type {import('vuex').Module}
 */
const module = {
  state: {
    t0050_rawData: [],
    t0063_rawData: [],
    monthArray: [],
    M21001_doBrowse_input: {},
    M21001_doBrowse_output: [],
    M21001_getBatchEdit_input: {},
    M21001_getBatchEdit_output: [],
    currentYear: null,
    hasUnsavedChanges: false,

    M21001_doBatchEdit_editableDateRange:{
      start_date: moment().add(1,'day').format('YYYY-MM-DD'),
      end_date: moment().add(1000,'year').format('YYYY-MM-DD'),
    },

    // Default Settings for each day of week, will update end_time_limit_no based on API data
    default_settings: [
      {
        // 0:月曜日
        label: '月曜日',
        start_time_limit_no: 50,
        end_time_limit_no: 82,
        closed_flag: 0,
      },
      {
        // 1:火曜日
        label: '火曜日',
        start_time_limit_no: 50,
        end_time_limit_no: 82,
        closed_flag: 0,
      },
      {
        // 2:水曜日
        label: '水曜日',
        start_time_limit_no: 50,
        end_time_limit_no: 82,
        closed_flag: 0,
      },
      {
        // 3:木曜日
        label: '木曜日',
        start_time_limit_no: 50,
        end_time_limit_no: 82,
        closed_flag: 0,
      },
      {
        // 4:金曜日
        label: '金曜日',
        start_time_limit_no: 50,
        end_time_limit_no: 82,
        closed_flag: 0,
      },
      {
        // 5:土曜日
        label: '土曜日',
        start_time_limit_no: 40,
        end_time_limit_no: 82,
        closed_flag: 0,
      },
      {
        // 6:日曜日
        label: '日曜日',
        start_time_limit_no: 10,
        end_time_limit_no: 82,
        closed_flag: 1,
      },
    ],
    // Default Time Limit List, will be replaced by API data
    timeLimitList: [
      { text: '1講', value: 1 },
      { text: '2講', value: 2 },
      { text: '3講', value: 3 },
      { text: '4講', value: 4 },
      { text: '5講', value: 5 },
      { text: '6講', value: 6 },
      { text: '7講', value: 7 },
      { text: '8講', value: 8 },
    ],
  },
  getters: {
    // map array of object to object of object using schedule_date

    // [{schedule_date: '2024-01-01', closed_flag:0}, {schedule_date: '2024-01-02', closed_flag:1}]
    // => { '2024-01-01': {schedule_date: '2024-01-01', closed_flag:0}, '2024-01-02': {schedule_date: '2024-01-02', closed_flag:1} }
    mapT0050Data: (state) => {
      const output = {}
      state.t0050_rawData.forEach(item => {
        output[item.schedule_date] = item
      })
      state.t0063_rawData.forEach(date => {
        output[date].regular_offday_flag = true
      })
      return output
    },
    editReady(state) {
      return state.t0050_rawData.length > 0
    },
    monthArray(state) {
      if(state.t0050_rawData.length === 0) return []
      const monthArray = []
      const start = moment(`${moment(state.t0050_rawData[0].schedule_date).year()}-04-01`)
      const end = moment(`${moment(state.t0050_rawData[0].schedule_date).year() + 1}-03-31`)
      const current = start.clone();
      while (current.isSameOrBefore(end, 'month')) {
        monthArray.push({
          monthIndex: current.month(),
          monthName: `${current.year()}年${current.month() + 1}月`,
          date: current.toDate(),
          daysInMonth: current.daysInMonth(),
          firstDayOfWeek: current.startOf('month').isoWeekday() - 1, // 0 (Mon) to 6 (Sun)
          year: current.year()
        });
        current.add(1, 'month');
      }
      return monthArray
    },
    isEditableDate: (state) => (dateStr) => {
      const date = moment(dateStr)
      if(!date.isValid()) return false
      if(!state.M21001_doBatchEdit_editableDateRange.start_date || !state.M21001_doBatchEdit_editableDateRange.end_date) return false
      const startDate = moment(state.M21001_doBatchEdit_editableDateRange.start_date)
      const endDate = moment(state.M21001_doBatchEdit_editableDateRange.end_date)
      return date.isBetween(startDate, endDate, 'day', '[]')
    }
  },
  mutations: {

  },
  actions: {
    async M21001_doBrowse ({ commit, state }, payload) {
      const res = await ApiUtils.postData({
        data: {
          M21001_doBrowse:{
            api: 'T0050CalendarService.M21001_doBrowse',
            input: state.M21001_doBrowse_input
          },
          M0040TimeLimit:{
            api: 'M0040TimeLimitService.doBrowseAll',
            input: {
              searchInfo: {
                not_time_division: 0
              }
            }
          },
        }
      })
      // 0001185
      const M0040TimeLimit = res.M0040TimeLimit.output
      const timeLimitGroupList = [...new Map(M0040TimeLimit.map(item => [item.time_limit_group_no, item])).values()];
      const newTimeLimitList = timeLimitGroupList.map(item => ({
        text: item.time_limit_group_name,
        value: parseInt(item.time_limit_group_no)
      }))
      const newDefaultSettings = state.default_settings.map(setting => {
        return {
          ...setting,
          end_time_limit_no: M0040TimeLimit[M0040TimeLimit.length - 1].time_limit_no,
        }
      })

      commit('setState', {
        M21001_doBrowse_output: res.M21001_doBrowse.output,
        timeLimitList: newTimeLimitList,
        default_settings: newDefaultSettings
      });
    },
    async M21001_getBatchEdit({ commit, state }, payload) {
      const year = payload.year
      const range = await this.dispatch('M21001/M21001_getYearRange', { year })

      // Set the current year and input parameters
      commit('setState', {
        currentYear: year,
        M21001_getBatchEdit_input: {
          start_date: range.startDate,
          end_date: range.endDate
        }
      })

      // eslint-disable-next-line no-useless-catch
      try {
        // Fetch calendar data for the specified year range
        const res = await ApiUtils.postData({
          data: {
            M21001_getBatchEdit: {
              api: 'T0050CalendarService.M21001_getCalendarByRange',
              input: state.M21001_getBatchEdit_input
            },
            M21001_getRegularOffday: {
              api: 'T0063RegularScheduleControlService.M21001_getRegularOffday',
              input: state.M21001_getBatchEdit_input
            }
          }
        })

        commit('setState', {
          M21001_getBatchEdit_output: res.M21001_getBatchEdit.output,
          t0050_rawData: res.M21001_getBatchEdit.output,
          t0063_rawData: res.M21001_getRegularOffday.output,
        })
      } catch (error) {
        throw error
      }
    },
    async M21001_doBatchEdit({ commit, state }, payload) {
      const t0063ScheduleDate = []
      state.t0050_rawData.forEach(item => {
        if(item.regular_offday_flag){
          t0063ScheduleDate.push(item.schedule_date)
        }
      })
      // Save calendar data for the year

      // eslint-disable-next-line no-useless-catch
      try {
        const res = await ApiUtils.postData({
          data: {
            M21001_doBatchEdit: {
              api: 'T0050CalendarService.M21001_doBatchEdit',
              input: {
                calendar_data: state.t0050_rawData,
                year: state.currentYear,
                start_date: state.M21001_getBatchEdit_input.start_date,
                end_date: state.M21001_getBatchEdit_input.end_date,
              }
            },
            M21001_updateRegularOffday: {
              api: 'T0063RegularScheduleControlService.M21001_updateRegularOffday',
              input: {
                start_date: state.M21001_getBatchEdit_input.start_date,
                end_date: state.M21001_getBatchEdit_input.end_date,
                schedule_date: t0063ScheduleDate,
              }
            },
          },
          databaseDiff: {
            tables: [
              't0050_calendar',
              't0063_regular_schedule_control',
            ]
          }
        })

        commit('setState', {
          t0050_rawData: res.M21001_doBatchEdit.output,
          hasUnsavedChanges: false
        })

        return res.M21001_doBatchEdit.output
      } catch (error) {
        throw error
      }
    },
    async M21001_getYearRange({ commit, state }, payload) {
      const year = parseInt(payload.year, 10)
      return {
        startDate: moment(`${year}-04-01`).format('YYYY-MM-DD'),
        endDate: moment(`${year+1}-03-31`).format('YYYY-MM-DD'),
      }
    },
    async M21001_generateFullYearTimeLimitList({ commit, state, dispatch }, payload) {
      const range = await dispatch('M21001_getYearRange',{year: payload.year})
      const fullYearData = []
      const currentDate = moment(range.startDate);
      const endDate = moment(range.endDate);

      while (currentDate.isSameOrBefore(endDate)) {
        const dateStr = currentDate.format('YYYY-MM-DD');
        const dayOfWeek = currentDate.isoWeekday() - 1; // 0 (Mon) to 6 (Sun)
        const dayEntry = {
          schedule_date: dateStr,
          dayofweek_code: dayOfWeek,
          closed_flag: state.default_settings[dayOfWeek].closed_flag,
          tstart_ime_limit_no: state.default_settings[dayOfWeek].start_time_limit_no,
          end_time_limit_no: state.default_settings[dayOfWeek].end_time_limit_no,
          remarks: '',
        }
        if(dayEntry.closed_flag === 1){
          dayEntry.tstart_ime_limit_no = 0
          dayEntry.end_time_limit_no = 0
        }
        fullYearData.push(dayEntry);
        currentDate.add(1, 'day');
      }

      commit('setState', {
        _removeReactivity: true,
        t0050_rawData: fullYearData,
        hasUnsavedChanges: true
      });
    },
  }
}

export default ObjArrUtils.merge(Base, module)
